import { CSSObject } from '@chakra-ui/react';

export const OddsText: CSSObject = {
  fontSize: 'sm',
  fontWeight: 'bold',
  color: 'white',
};

export const MultiCardContainer: CSSObject = {
  borderTop: '1px dashed',
  borderColor: 'blackAlpha.300',
  mx: '2.5',
  py: '2',
  px: '0.5',
};

export const OddsMultiCard: CSSObject = {
  fontWeight: 'semibold',
  color: 'white',
  fontSize: 'xs',
};
